import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("rect", {
  x: "0.75",
  y: "0.75",
  width: "22.5",
  height: "22.5",
  rx: "11.25",
  stroke: "currentColor",
  "stroke-opacity": "0.2745",
  "stroke-width": "1.5",
  "stroke-dasharray": "3 3"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M12.0002 5.33325C10.3433 5.33325 9.00016 6.6764 9.00016 8.33325C9.00016 9.99011 10.3433 11.3333 12.0002 11.3333C13.657 11.3333 15.0002 9.99011 15.0002 8.33325C15.0002 6.6764 13.657 5.33325 12.0002 5.33325Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  d: "M12.0012 11.9999C9.44655 11.9999 7.4914 13.5307 6.69753 15.6773C6.47057 16.2909 6.62596 16.8958 6.98673 17.3257C7.33831 17.7447 7.88105 17.9999 8.46571 17.9999H15.5366C16.1213 17.9999 16.664 17.7447 17.0156 17.3257C17.3763 16.8958 17.5317 16.2909 17.3048 15.6773C16.5109 13.5307 14.5558 11.9999 12.0012 11.9999Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_5]))
}
export default { render: render }